import api from '../api';
import { CreateFaleConoscoDto, FaleConoscoResponse, ApiError } from './types';

export class FaleConoscoService {
  /**
   * Envia uma mensagem de contato
   * @param contatoData - Dados do contato
   * @returns Promise com resposta do contato enviado
   */
  static async enviarContato(contatoData: CreateFaleConoscoDto): Promise<FaleConoscoResponse> {
    try {
      // Remover o interceptor de token para este endpoint público
      const response = await api.post<FaleConoscoResponse>('/fale-conosco', contatoData, {
        headers: {
          Authorization: undefined, // Remove o token para endpoint público
        },
      });
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || 'Erro na requisição',
        statusCode: error.response.status,
        error: error.response.data.error,
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}
